import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import buildingimage from "../img/image.jpg";
import dummyImage from '../img/ast_ylw_logo.png';
import AuthenticatedImage from "./AuthenticatedImage";
import "./home.css";

function Home() {
  const [tournaments, setTournaments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tournamentsLoading, setTournamentsLoading] = useState(false);
  const [error, setError] = useState("");
  const [currentTournamentIndex, setCurrentTournamentIndex] = useState(0);
  const navigate = useNavigate();

  // Updated function to construct proper image URL for tournament logos
  const constructImageUrl = (imagePath) => {
    if (!imagePath) return null;
    
    // If it's already a full URL, return as is
    if (imagePath.startsWith('http')) {
      return imagePath;
    }
    
    // Use the specific tournament logos API endpoint
    const baseUrl = "https://api.asterickx.com/api/Assets/TournamentLogos/";
    
    // Remove any leading slashes, "Assets/", or "TournamentLogos/" prefix
    let cleanPath = imagePath
      .replace(/^\/+/, '')
      .replace(/^Assets\//, '')
      .replace(/^TournamentLogos\//, '');
    
    return baseUrl + cleanPath;
  };

  // Function to fetch tournaments
  const fetchTournaments = useCallback(async () => {
    const token = localStorage.getItem("token");
    console.log("=== Fetching tournaments ===");
    
    setTournamentsLoading(true);

    try {
      const tournamentsResponse = await fetch("https://api.asterickx.com/api/Tournaments", {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
      });

      if (!tournamentsResponse.ok) {
        throw new Error(`Tournament API error! Status: ${tournamentsResponse.status}`);
      }

      const tournamentData = await tournamentsResponse.json();
      console.log("All tournaments:", tournamentData);

      if (tournamentData && tournamentData.length > 0) {
        const currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0);

        // Filter active tournaments that haven't ended
        const activeTournaments = tournamentData.filter((tournament) => {
          const endDate = new Date(tournament.endDate);
          const isNotExpired = endDate >= currentDate;
          const isActive = tournament.status && tournament.status.toLowerCase() === 'active';
          console.log(`Tournament ${tournament.tournamentName}: Active=${isActive}, NotExpired=${isNotExpired}`);
          return isNotExpired && isActive;
        });

        console.log("Active tournaments:", activeTournaments);

        // Sort by start date
        const sortedTournaments = activeTournaments.sort(
          (a, b) => new Date(a.startDate) - new Date(b.startDate)
        );

        // Construct tournament data with proper image URLs
        const tournamentsData = sortedTournaments.map((tournament, index) => {
          console.log(`Processing tournament: ${tournament.tournamentName}, Logo: ${tournament.tournamentLogo}`);
          
          return {
            id: tournament.tournamentId,
            name: tournament.tournamentName,
            logo: constructImageUrl(tournament.tournamentLogo),
            logoFileName: tournament.tournamentLogo,
            venue: tournament.venue,
            startDate: tournament.startDate,
            endDate: tournament.endDate,
            status: tournament.status,
          };
        });

        console.log("Final tournaments data:", tournamentsData);
        setTournaments(tournamentsData);
        setError("");
      } else {
        console.log("No tournaments available");
        setError("No tournaments available");
        setTournaments([]);
      }

    } catch (error) {
      console.error("Error fetching tournaments:", error);
      setError("Failed to load tournament data. Please try again.");
      setTournaments([]);
    } finally {
      setTournamentsLoading(false);
      setLoading(false);
    }
  }, []);

  // Fetch tournament data on component mount
  useEffect(() => {
    fetchTournaments();
  }, [fetchTournaments]);

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    
    try {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    } catch (error) {
      console.error("Error formatting date:", error);
      return "Invalid Date";
    }
  };

  // ✅ UPDATED: Handle tournament click - Navigate to tournament details
  const handleTournamentClick = (tournament) => {
    // navigate('/tournamentalldetails', { state: { tournament } });
    // For now, clicking card navigates to draws
    navigate(`/tournament-draws/${tournament.id}`);
  };

  // // ✅ NEW: Handle View Draws button click
  // const handleViewDraws = (e, tournament) => {
  //   e.stopPropagation(); // Prevent card click event
  //   navigate(`/tournament-draws/${tournament.id}`);
  // };

// ✅ NEW CODE:
const handleViewDraws = (e, tournament) => {
  e.stopPropagation();
  navigate(`/tournament-sports/${tournament.id}`); // ← Changed!
};

  // ✅ NEW: Handle View Dashboard button click
  const handleViewDashboard = (e, tournament) => {
    e.stopPropagation(); // Prevent card click event
    navigate(`/tournament-dashboard/${tournament.id}`);
  };

  // Carousel navigation functions
  const nextTournaments = () => {
    if (tournaments.length > 3) {
      setCurrentTournamentIndex((prev) => (prev + 3) % tournaments.length);
    }
  };

  const prevTournaments = () => {
    if (tournaments.length > 3) {
      setCurrentTournamentIndex((prev) => (prev - 3 + tournaments.length) % tournaments.length);
    }
  };

  // Get visible items for carousel
  const getVisibleTournaments = () => {
    if (!tournaments || tournaments.length === 0) return [];
    const visible = [];
    for (let i = 0; i < Math.min(3, tournaments.length); i++) {
      const index = (currentTournamentIndex + i) % tournaments.length;
      visible.push(tournaments[index]);
    }
    return visible;
  };

  return (
    <div>
      <main className="App-content">
        <section className="main-layout">
          <div className="text-content">
            <h1>Where Tournaments Rise</h1>
            <p><i>From planning to podiums, Asterickx powers every competition.</i></p>
            <p>Built for organizers, trusted by teams, and designed to scale from local leagues to elite tournaments.</p>
          </div>
        </section>
      </main>

      {/* Active Tournaments Section */}
      <main className="tournaments-section" id="tournaments">
        <section className="tournamentspage">
          <div className="container">
            <div className="row bg-light py-5 tournament-section">
              <div className="col-12 text-center">
                <h3>Active Tournaments</h3>
                <p className="text-muted">Click on a tournament to view complete details</p>
              </div>
              <div className="col-12">
                {tournamentsLoading ? (
                  <div className="carousel-loading">Loading tournaments...</div>
                ) : tournaments.length > 0 ? (
                  <div className={`carousel-container ${tournaments.length <= 3 ? 'carousel-single-page' : ''}`}>
                    <div className="carousel-wrapper">
                      {tournaments.length > 3 && (
                        <button 
                          className="carousel-btn"
                          onClick={prevTournaments}
                          aria-label="Previous tournaments"
                        >
                          ‹
                        </button>
                      )}
                      
                      <div className="carousel-content">
                        {getVisibleTournaments().map((tournament, index) => (
                          <div 
                            key={`tournament-${tournament.id}-${index}`} 
                            className="tournament-card-container"
                            onClick={() => handleTournamentClick(tournament)}
                            style={{ cursor: 'pointer' }}
                          >
                            <div className="tournament-card">
                              <AuthenticatedImage
                                src={tournament.logo}
                                alt={tournament.name || "Tournament Logo"}
                                className="tournament-logo"
                                fallbackSrc={dummyImage}
                              />
                              <div className="tournament-info">
                                <h5 className="tournament-name">{tournament.name}</h5>
                                <p className="tournament-start-date">
                                  <strong>Start Date:</strong> {formatDate(tournament.startDate)}
                                </p>
                                <p className="tournament-venue">
                                  <strong>Venue:</strong> {tournament.venue}
                                </p>
                                
                                {/* ✅ NEW: Action Buttons */}
                                <div className="tournament-actions">
                                  <button
                                    className="tournament-btn btn-draws"
                                    onClick={(e) => handleViewDraws(e, tournament)}
                                    title="View Tournament Draws & Groups"
                                  >
                                    <i className="fas fa-sitemap me-1"></i>
                                    View Draws
                                  </button>
                                  <button
                                    className="tournament-btn btn-dashboard"
                                    onClick={(e) => handleViewDashboard(e, tournament)}
                                    title="View Tournament Dashboard"
                                  >
                                    <i className="fas fa-chart-line me-1"></i>
                                    Dashboard
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>

                      {tournaments.length > 3 && (
                        <button 
                          className="carousel-btn"
                          onClick={nextTournaments}
                          aria-label="Next tournaments"
                        >
                          ›
                        </button>
                      )}
                    </div>
                  </div>
                ) : (
                  <div className="carousel-empty">No active tournaments available</div>
                )}
              </div>
            </div>
          </div>
        </section>
      </main>

      {/* About Us Section */}
      <main className="about-us-section" id="about-us">
        <section className="about-us-page">
          <div className="container-fluid row align-items-center py-5 bg-light">
            <div className="col-md-6 text-center">
              <img
                src={buildingimage}
                alt="About Us"
                className="img-fluid rounded"
                style={{ maxWidth: "75%", height: "auto" }}
              />
            </div>
            <div className="col-md-6 d-flex flex-column text-center text-md-start">
              <h3 className="mb-3" style={{ padding: "10px 15px" }}>About Us</h3>
              <p className="padded-text" style={{ padding: "10px 15px" }}>
                <b>'Asterickx'</b> is a modern sports management platform built to simplify how tournaments are created, managed, and monitored.
              </p>
              <p className="padded-text" style={{ padding: "10px 15px" }}>
                We empower organizers to run competitions across multiple sports with greater speed, accuracy, and control — all from a single, intuitive platform.
                <p>From planning fixtures and managing teams to tracking results and delivering seamless tournament experiences, Asterickx brings structure and clarity to every stage of competition. Whether it's a local league or a large-scale championship, our platform is designed to scale, perform, and adapt.</p>
                <p>At Asterickx, we believe - <b>Great tournaments deserve great technology — so organizers can focus on the game, and athletes can focus on winning.</b></p>
              </p>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}

export default Home;